module.exports = __webpack_public_path__ + "img/ocean-hotel-2.0a212d20.jpg";